import React from 'react'
import { AlertTriangle, ShieldAlert, Flag } from 'lucide-react'
import Badge from './Badge'

/**
 * Domain-specific flag chip — encodes the most-frequent journalistic
 * signals as a single typed component so meaning stays consistent across
 * profile, list, and graph views.
 *
 *   - "foreign":      ejer/deltager registreret med adresse uden for DK
 *   - "protected":    beskyttet adresse i CVR
 *   - "historic":     historisk (ikke-aktuel) rolle
 */
export type FlagKind = 'foreign' | 'protected' | 'historic'

interface FlagChipProps {
  kind: FlagKind
  /** Optional ISO country code (for foreign), shown in the label. */
  countryCode?: string | null
  className?: string
}

const FlagChip: React.FC<FlagChipProps> = ({ kind, countryCode, className }) => {
  if (kind === 'foreign') {
    return (
      <Badge tone="signal" title={`Adresse i ${countryCode ?? 'udlandet'}`} className={className}>
        <Flag className="h-3 w-3" aria-hidden />
        Udenlandsk{countryCode ? ` (${countryCode})` : ''}
      </Badge>
    )
  }
  if (kind === 'protected') {
    return (
      <Badge tone="signal" title="Beskyttet adresse" className={className}>
        <ShieldAlert className="h-3 w-3" aria-hidden />
        Beskyttet adresse
      </Badge>
    )
  }
  return (
    <Badge tone="muted" title="Historisk rolle" className={className}>
      <AlertTriangle className="h-3 w-3" aria-hidden />
      Historisk
    </Badge>
  )
}

export default FlagChip
